import { Component, OnInit, Inject, Optional, Input } from '@angular/core';
import { BaseComponent } from '@tytapp/common';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { ExpressResponse } from '@tytapp/common';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { AppApi } from '@tytapp/api';
import { Redirection } from '@tytapp/common/redirection';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent extends BaseComponent {

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        @Inject(RESPONSE) @Optional()
        private response: ExpressResponse,
        private appApi: AppApi,
        private redirection: Redirection
    ) {
        super();
    }

    static routes: Route[] = [];

    settled: boolean = false;

    @Input()
    checkRedirect: boolean = true;

    async init() {
        let url = this.route.snapshot.url.join('/');
        let serverSide = typeof window === 'undefined';
        let hasRedirect = false;

        if (!serverSide && this.checkRedirect) {
            let response: any = null;

            try {
                response = <any>await this.appApi.lookupRedirect(url).toPromise();
            } catch (e) {
                if (e.statusCode === 404) {
                    response = null;
                    return;
                }

                if (e.json)
                    e = e.json();

                console.error(`Failed to lookup redirect:`);
                console.error(e);
                response = null;
            }

            if (response && response.url) {
                hasRedirect = true;
                this.redirection.go(response.url);
            }
        }

        if (!hasRedirect) {
            let url = this.route.snapshot.url.join('/');
            let urlAdjusted = false;
            for (let route of PageNotFoundComponent.routes) {
                let routePath = route.path.replace(/:.*/, '');
                let lowerUrl = url.toLowerCase();
                if (lowerUrl === routePath || lowerUrl.startsWith(`${routePath}/`)) {
                    const newUrl = `${route.path}/${url.slice(route.path.length + 1)}`;
                    if (newUrl !== url) {
                        url = newUrl;
                        urlAdjusted = true;
                        break;
                    }
                }
            }

            if (urlAdjusted) {
                hasRedirect = true;
                this.redirection.go(`/${ url }`);
            }
        }

        if (!hasRedirect) {
            this.settled = true;
        }

        if (this.response) {
            this.response.status(404);
            this.response.header('Cache-Control', 'no-cache');
        }
    }

    permanentRedirect(url) {
        if (typeof window === 'undefined' && this.response) {
            // Permanent redirect
            this.response.redirect(301, url);
        } else {
            this.router.navigate([url]);
        }
    }

}
